<template>
  <div class="DateDropDownSelect" :class="getStyle('title')">
    <div class="dis-block">
      <numberSelection
        v-if="displaySelection"
        :selectApi="selectApi"
        :numberSelectData="numberSelectData"
        @numberChange="numberChange"
      ></numberSelection>
      <textSelection
        v-if="!displaySelection && !displayHoliday"
        :selectApi="selectApi"
        :textSelectData="textSelectData"
        @textChange="textChange"
      ></textSelection>
      <holidaySelection
        v-if="displayHoliday"
        :selectApi="selectApi"
        :holidayData="holidayData"
        @holidayChange="holidayChange"
      ></holidaySelection>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex';
import numberSelection from './numberSelection';
import textSelection from './textSelection';
import holidaySelection from './holidaySelection.vue';
export default {
  name: 'DateDropDownSelect',
  props: {
    selectData: Array,
    selectApi: String,
  },
  components: {
    numberSelection,
    textSelection,
    holidaySelection,
  },
  data() {
    return {
      displaySelection: true,
      displayHoliday: false,
      years: [''],
      months: [''],
      year: '',
      month: '',
      day: '',
      booDecideTitle: false,
      selectValve: '',
      selectValve2: '',
      selectThird: '',
      selectChildData: {},
      childData: false,
      childThirdData: false,
      childData1: {},
      watchNewm: '',
      watchNewy: '',
      watchMootm: '',
      currentChartsList: null,
      days: [],
      data: [
        {
          label: '按年',
          value: 'year',
          modelValue: '年',
        },
        {
          label: '按半年',
          value: 'halfyear',
          modelValue: '半年',
        },
        {
          label: '按季度',
          value: 'quarter',
          modelValue: '2022',
        },
        {
          label: '按月',
          value: 'month',
          modelValue: '2022',
        },
      ],
      textSelectData: [],
      numberSelectData: [],
      holidayData: [],
    };
  },
  computed: {
    ...mapState({
      componentName: state => state.ProjectInfo.CurrentScene.Charts,
      currentECharts: state => state.ProjectInfo.CurrentScene.Charts,
    }),
  },
  watch: {
    componentName: {
      handler() {},
      immediate: true,
    },
    currentECharts: {
      handler(val) {
        this.currentChartsList = val;
      },
      immediate: true,
    },

    watchMootm: {
      handler(newM) {
        this.watchNewm = newM;
      },
      immediate: true,
    },
    selectValve: {
      handler(newY) {
        this.watchNewy = newY;
      },
      immediate: true,
    },
  },
  mounted() {
    this.chartIdHandle();
    if (this.selectApi.currenEntry === 'staticData') {
      //   // 判断未连接api数据
      this.selectValve = this.data[0];
    } else {
      console.log(this.selectData, 'w433435345345');

      // 检查是否有节假日数据
      const hasFestivalData =
        this.selectData[0]?.modelValue == 'festival' ||
        this.selectData[0]?.children?.some(c => c.label === '春节假期');

      if (this.selectData[0]?.modelValue == 'characters') {
        this.displaySelection = false;
        this.displayHoliday = false;
        this.textSelectData = this.selectData;
      } else if (hasFestivalData) {
        // 处理节假日数据
        this.displaySelection = false;
        this.displayHoliday = true;
        this.holidayData = this.selectData;
      } else if (this.selectData[0]?.modelValue == 'DowTrue') {
        this.displaySelection = true;
        this.displayHoliday = false;
        this.numberSelectData = this.selectData;
      }
      // 已连接api
      // this.data = JSON.parse(JSON.stringify(this.selectData));
      // console.log(this.data, '56656626476');
      // this.selectValve = this.data[0];
      // var myDate = new Date();
      // var year = myDate.getFullYear(); //获取年
      // var month = myDate.getMonth() + 1; //获取当前月
      // var dayVal = myDate.getDate(); //获取当前日
      // this.$nextTick(() => {
      //   let selectMonth = {};
      //   this.selectValve?.children?.forEach(mon => {
      //     if (month == mon.value) {
      //       selectMonth = mon;
      //     }
      //   });
      //   if (this.selectValve?.modelValue == 'DowTrue') {
      //     this.selectValve2 = selectMonth;
      //     this.watchMootm = this.selectValve.children[0].value;
      //     this.selectChildData = this.selectValve.children;
      //     this.childData = true;
      //   } else if (this.selectChildData[0]?.third == 'Third') {
      //     this.selectValve2 = selectMonth;
      //     this.selectThird = dayVal + '日';
      //     this.getDate();
      //     this.childThirdData = true;
      //   } else if (this.selectValve?.modelValue == 'Year') {
      //     let selectYear = {};
      //     this.data = this.selectValve.data;
      //     this.selectValve?.data?.forEach(yitem => {
      //       if (year == yitem.value) {
      //         selectYear = year;
      //       } else {
      //       }
      //     });
      //     this.selectValve = selectYear;
      //   }
      // });
    }
  },
  methods: {
    // selectPosition() {
    //   this.currentChartsList.forEach(char => {
    //     console.log(char, '564464846464648');
    //     if (char.componentTitle != '组合组件') {
    //       return {
    //         right: `4% !important`,
    //         position: 'absolute !important',
    //         top: `-22px !important`,
    //       };
    //     } else {
    //       return {
    //         position: 'absolute !important',
    //         top: `-22px  !important`,
    //         right: `16% !important`,
    //       };
    //     }
    //   });
    // },
    chartIdHandle() {
      this.componentName.forEach(chartId => {
        if (chartId.id == 'qaArRwek9hdncVSe25l1G') {
          this.booDecideTitle = true;
        }
      });
    },

    getStyle(e = '') {
      let style = {};
      let bool = e == 'title';
      switch (this.style) {
        case 'V1Style':
          style = {};
          if (bool) style['V1StyleTitle'] = true;
          style['V1Style'] = true;
          break;
        case 'V2Style':
          style = {};
          if (bool) style['V2StyleTitle'] = true;
          style['V2Style'] = true;
          break;
        case 'V3Style':
          style = {};
          if (bool) style['V3StyleTitle'] = true;
          style['V3Style'] = true;
          break;
        case 'V4Style':
          style = {};
          if (bool) style['V4StyleTitle'] = true;
          style['V4Style'] = true;
          break;
        case 'V5Style':
          style = {};
          if (bool) style['V5StyleTitle'] = true;
          style['V5Style'] = true;
          break;
        case 'V6Style':
          style = {};
          if (bool) style['V6StyleTitle'] = true;
          style['V6Style'] = true;
          break;
        case 'V7Style':
          style = {};
          if (bool) style['V7StyleTitle'] = true;
          style['V7Style'] = true;
          break;
        case 'V8Style':
          style = {};
          if (bool) style['V8StyleTitle'] = true;
          style['V8Style'] = true;
          break;
        case 'V9Style':
          style = {};
          if (bool) style['V9StyleTitle'] = true;
          style['V9Style'] = true;
          break;
        case 'V10Style':
          style = {};
          if (bool) style['V10StyleTitle'] = true;
          style['V10Style'] = true;
          break;
        case 'V11Style':
          style = {};
          if (bool) style['V11StyleTitle'] = true;
          style['V11Style'] = true;
          break;
        default:
          break;
      }
      return style;
    },
    // handleSelect() {
    //   let value1 = this.selectValve.value;
    //   let value2 = this.selectValve2.value;
    //   let value3 = this.selectThird.value;

    //   // 月 和 天为 false
    //   if (this.childData == false && this.childThirdData == false) {
    //     // 只传 一个 值
    //     this.$emit('selectChange', value1);
    //   } else if (this.childData == true && this.childThirdData == false) {
    //     this.$emit('selectChange', `${value1}-${value2}`);
    //   } else if (this.childData == true && this.childThirdData == true) {
    //     this.$emit('selectChange', `${value1}-${value2}-${value3}`);
    //   }
    // },
    textChange(val) {
      this.$emit('selectChange', val);
    },
    numberChange(val) {
      this.$emit('selectChange', val);
    },
    holidayChange(val) {
      this.$emit('selectChange', val);
    },
    // getDate() {
    //   this.day = [];
    //   //计算 选择月 的天数
    //   this.$nextTick(() => {
    //     let day = this.getDaysInMonth(this.watchNewy.value, this.watchNewm);
    //     for (let i = 1; i <= day; i++) {
    //       this.day.push({
    //         label: i + '日',
    //         value: i,
    //       });
    //     }
    //     this.day.forEach(item => {
    //       if (item.value < 10) {
    //         item.value = '0' + item.value;
    //       }
    //     });
    //   });
    // },
    // getDaysInMonth(year, month) {
    //   month = parseInt(month, 10);
    //   let d = new Date(year, month, 0);
    //   return d.getDate();
    // },
  },
};
</script>

<style lang="scss" scoped>
.V11Style {
  :deep().drop-down-select .el-input__inner {
    border: 1px solid #c63a36 !important;
    color: #fff !important;
  }
  :deep().el-icon-arrow-up:before {
    color: #fff !important;
  }
}
/* .DateDropDownSelect {
  position: relative;
}

.drop-down-select {
  margin-left: 4px;
}

:deep().drop-down-select .el-input__inner {
  width: 72px; 
  height: 22px;
  line-height: 22px;
  padding-left: 10px;
  padding-right: 20px;
  background: none;
  border: 1px solid #148cdb;
  color: #03b8ca;
  font-size: 12px;
  position: relative;
}

:deep().el-input--small .el-input__icon {
  line-height: 22px;
}

:deep().el-input__suffix {
  right: 0;
  top: -8px;

  .el-input__suffix-inner {
    margin: 0;
  }
}

:deep().drop-down-select {
  &:nth-child(n + 2) {
    .el-input__inner {
      width: 60px;
    }
  }
}

:deep().el-select__popper.el-popper {
  background: none !important;
}

:deep().el-icon-arrow-up:before {
  color: #00f4fd;
}

.V3Style {
  :deep().drop-down-select .el-input__inner {
    width: 94px;
    height: 24px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #148cdb;
    color: #03b8ca;
    font-size: 12px;
    background: linear-gradient(to top, #0c2b67, #031639, #0c2b67);
  }

  :deep().el-icon-arrow-up:before {
    color: #1597e6;
  }
}

.V4Style {
  :deep().drop-down-select .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #8d77d8;
    color: #fff;
    font-size: 12px;
  }

  :deep().el-icon-arrow-up:before {
    color: #8d77d8;
  }
}

.V5Style {
  :deep().drop-down-select .el-input__inner {
    width: 80px;
    height: 22px;
    line-height: 22px;
    padding-left: 10px;
    padding-right: 20px;
    background: none;
    border: 1px solid #03a252;
    color: #fff;
    font-size: 12px;
  }

  :deep().el-icon-arrow-up:before {
    color: #03a252;
  }
} */
</style>
